// extracted by mini-css-extract-plugin
export default {"Main":"ErrorMessage_Main__VDZ54"};